import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';
import './Projects.css';

const Projects = () => {
  const { t } = useLanguage();
  const navigate = useNavigate();

  const handleProjectClick = (project, index) => {
    if (project.canOpenDetails) {
      navigate(`/project/${index}`);
    }
  };

  return (
    <>
      <div style={{ clear: 'both' }} />
      <div className="projects-section" id="section-projects">
        <div className="projects-wrap row">
          <div className="projects-title">
            <h4>{t.projects.title}</h4>
            <p>{t.projects.subtitle}</p>
          </div>
          <div style={{ clear: 'both' }} />

          <div className="projects-grid">
            {t.projects.items.map((project, index) => (
              <div
                key={index}
                className={`project-card ${!project.canOpenDetails ? 'disabled' : ''}`}
                onClick={() => handleProjectClick(project, index)}
                style={{ cursor: project.canOpenDetails ? 'pointer' : 'not-allowed' }}
              >
                <div className="project-image">
                  <img src={project.image} alt={project.title} />
                  {project.category && (
                    <div className="project-category">{project.category}</div>
                  )}
                  {project.canOpenDetails && <div className="project-overlay"></div>}
                </div>
                <div className="project-content">
                  <h5 className="project-name">{project.title}</h5>
                  {/*<p className="project-description">{project.description}</p>*/}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

export default Projects;
